export default function Hero() {
  return (
    <div className="max-w-7xl mx-auto text-center">
      <h1 className="text-6xl font-bold leading-tight">
        Bramacc</h1><h2> ERP Platform for Enterprise Business
      </h2>

      <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
        Accounting, inventory, warehouse, purchasing,
        POS, and reporting in one integrated platform.
      </p>

      <div className="mt-10 flex justify-center gap-4">
        <button className="px-6 py-3 rounded-xl bg-black text-white">
          Start Free Trial
        </button>

        <button className="px-6 py-3 rounded-xl border">
          Watch Demo
        </button>
      </div>
    </div>
  );
}
